import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home';
import BookingPage from './Pages/Bookingpage';
import Loader from './Components/Loader/loader';
import Testimonials from './Pages/Testimonials';
import AboutMe from './Pages/About';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      const textLoadTimer = setTimeout(() => {
        setIsLoading(false);
      }, 2000);

      return () => clearTimeout(textLoadTimer);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutMe />} />
            <Route path="/testimonials" element={<Testimonials/>} />
            <Route path="/bookingpage" element={<BookingPage />} />
          </Routes>
        </div>
      )}
    </Router>
  );
}

export default App;